export const UPDATE_UI = 'UPDATE_UI';
export const UPDATE_UI_RAW = 'UPDATE_UI_RAW';
export const UPDATE_MODALS = 'UPDATE_MODALS';
